import styles from './ClientOrderList.module.css'
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import TableItem, {TableItemCurrentStateInt} from "../../FormTemplate/TableItem/TableItem";
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import SignatureCanvas from "react-signature-canvas";
import ModalWindow from "../../FormTemplate/ModalWindow/ModalWindow";
import {readFile} from "fs";
import {text} from "stream/consumers";
import OrderEngineStatus from "../../LK/OrderEngine/Status/OrderEngineStatus";
import ClientOrderAppeal from "./ClientOrderAppeal";
import ClientOrderRefund from "./ClientOrderRefund";
import ClientOrderRecall from "./ClientOrderRecall";


interface RefundDataInt
{
    text:string
    phone:string
    eMail:string
    payData:string
}
interface RecallDataInt
{
    phone:string
}

interface AppealDataInt
{
    text:string
}




export interface AddFeedBackInt
{
    author:string;
    text:string;
    type:number;
    parent:number;
    phone?:string;
    eMail?:string;
    xData?:string;
    yData?:string;
    capt:string;
}


interface ClientOrderInfoInt
{
    orderId: string
    createDate: string
    state:string

    region: string
    tarif:string
    ctn:string
    operId:string

    customer:string
    track:string
    deliveryCtn:string
    address:string
    client:string

    pay:string
    payId:string
    billUrl:string
    regMode:number
    phone?:string
    eMail?:string
    amount: number
    note:string
    regModeText:string
    stateText:string
    tmpCtn?:string

}

export default function ClientOrderList(){

    const [baseState, setBaseState] = useState<TableItemCurrentStateInt>()
    const [defPhone,setDefPhone] = useState("")
    const [defEMail,setDefEMail] = useState("")



    const addFeedBackData = useRef<AddFeedBackInt>()
    const [ldrAddFeedback,rsAddFeedback,exAddFeedback] = useApiQuery("/appeal/add","post",addFeedBackData);


    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const orderListData = useRef()
    const [ldrOrderList,rsOrderList,exOrderList] = useApiQuery("/sell/sim/client/order/list","get",orderListData);

    const orderInfoData = useRef({
        orderId:""
    })
    const [ldrOrderInfo,rsOrderInfo,exOrderInfo] = useApiQuery("/sell/sim/client/order/info","post",orderInfoData);
    const [orderInfo, setOrderInfo] = useState<ClientOrderInfoInt>()


    const orderBillData = useRef({
        orderId:""
    })
    const [ldrOrderBill,rsOrderBill,exOrderBill] = useApiQuery("/sell/sim/client/order/bill","post",orderBillData);

    const [showAppeal, setShowAppeal] = useState(false)
    const [showRefund, setShowRefund] = useState(false)
    const [showRecall, setShowRecall] = useState(false)
    const [showOrderStatus, setShowOrderStatus] = useState(false)



    const [orderList, setOrderList] = useState<any[]>([])
    const [userInfo, setUserInfo] = useState<any>()

    const [orderId, setOrderId] = useState("")


    const [reqActivate , setReqActivate] = useState(true)




    useEffect(()=>{
        loadOrderList()
    },[orderListData])


    useEffect(()=>{
        console.log("base state", baseState)
    },[baseState])

    useEffect(()=>{
        if(orderId)loadOrderInfo()
    },[orderId])

    const loadOrderInfo = () =>{
        if(! orderId) return
        orderInfoData.current = {
            orderId: orderId
        }
        exOrderInfo().then((e)=>{
            if(e?.success)
            {
                setOrderInfo(e?.payload)
                if(e?.payload?.phone && e?.payload?.phone?.match(/^((\+7)|(8)|(^))9[0-9]{9}$/ui))
                {
                    setDefPhone(e?.payload?.phone)
                }
                if(e?.payload?.eMail && e?.payload?.eMail?.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ui))
                {
                    setDefEMail(e?.payload?.eMail)
                }
                return
            }
            setOrderInfo(undefined)
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера", true,2000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера", true,2000)
            setOrderInfo(undefined)
        })
    }

    const loadOrderList = () =>{
        exOrderList().then((e)=>{
            if(e?.success)
            {
                setOrderList(e?.payload?.orderList)
                setUserInfo(e?.payload?.user)
                if(e?.payload?.orderList && Array.isArray(e?.payload?.orderList) && e?.payload?.orderList?.length)
                {
                    const startOrder = e?.payload?.orderList[0]
                    setOrderId(startOrder?.orderId)
                    setBaseState({
                        page:0,
                        id: startOrder?.id
                    })
                }

            }
        })
    }

    const buildOrderList = () =>{
        return orderList.map((item,idx)=>{
            return(
                <div key={idx} className={["d-flex row", styles.orRow].join(' ')}>
                    <div className={"d-flex col-sm-1"}>{item?.orderId}</div>
                    <div className={"d-flex col-sm-1"}>{item?.operId}</div>
                    <div className={"d-flex col-sm-1"}>{item?.state}</div>
                </div>
            )
        })
    }

    const getCtnTypeText = () =>{
        switch (orderInfo?.regMode)
        {
            case 10:return `[MNP] Номер`
            default: return "Номер"
        }
    }


    const handleBill = () =>{
        orderBillData.current.orderId = orderInfo?.orderId ? orderInfo?.orderId : "-1"
        //console.log(orderBillData.current)
        exOrderBill().then((e)=>{
            //console.log(e)
            if(e?.success) {
                try {
                    e?.payload.blob().then((blob: any) => {
                        const fileURL = window.URL.createObjectURL(blob);
                        let alink = document.createElement("a");
                        alink.href = fileURL;
                        alink.download = "SamplePDF.pdf";
                        alink.click();
                    })

                } catch (e) {
                    console.log(e)
                }
            }


        }).catch((e)=>{
            console.log(e)
        })
    }


    const handleRequestActivate = ()=>{


        addFeedBackData.current = {
            type: 2,
            author: orderInfo?.client ? orderInfo?.client : "Клиент",
            parent: 0,
            xData: orderId,
            text: "Запрос активации",
            capt:""
        }

        setReqActivate(false)
        setTimeout(()=>setReqActivate(true), 60000)

        exAddFeedback().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef?.current)errorLineRef?.current?.show("Запрос отправлен, ожидайте ответа - меню [Обращения]", false,0)
                return

            }
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера", true,2000)
        }).catch((e)=>{
            if(errorLineRef?.current)errorLineRef?.current?.show(e?.errorAsString ?  e?.errorAsString : "Ошибка сервера", true,2000)

        })

    }

    return(
        <div className={styles.mainCont}>
            {showAppeal &&
                <ClientOrderAppeal orderId={orderId} author={orderInfo?.client ? orderInfo?.client : "Клиент"} onClose={()=>setShowAppeal(false)}></ClientOrderAppeal>
            }
            {showRefund &&
                <ClientOrderRefund orderId={orderId} author={orderInfo?.client ? orderInfo?.client : "Клиент"} defPhone={defPhone} defEMail={defEMail} onClose={()=>setShowRefund(false)}></ClientOrderRefund>
            }
            {showRecall &&
                <ClientOrderRecall orderId={orderId} author={orderInfo?.client ? orderInfo?.client : "Клиент"} defPhone={defPhone} onClose={()=>setShowRecall(false)}></ClientOrderRecall>
            }
            <MainFormTemplate title={`Карточка заказа ${orderId?.length ? `[ ${orderId} ]` : ""}`} maxWidth={"90%"}>

                <div className={styles.titleCont}>
                    <ActiveRecordItem active={!!orderId}></ActiveRecordItem>
                    <WaitLoader loading={ldrOrderInfo || ldrAddFeedback} api={rsOrderInfo} onlyLoading={true}>

                    </WaitLoader>

                </div>


                <div className={styles.rowCont}>
                    <div className={styles.itmCont}>
                        <div className={styles.orTitle}>Данные заказа</div>
                        <div className={"row w-100"}>
                            <div className={["col-xl-4  col-lg-6 col-md-6", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.createDate ? orderInfo?.createDate : ""}
                                    mode={"i"}
                                    info={"Дата  создания заказа"}
                                    title={"Дата заказа"}
                                    titleShift={1}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-4   col-lg-6 col-md-6", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.orderId ? orderInfo?.orderId : ""}
                                    mode={"i"}
                                    info={"Номер заказа в системе"}
                                    title={"Номер заказа"}
                                    titleShift={2}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-4   col-lg-12", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.regModeText ? orderInfo?.regModeText : "-"}
                                    mode={"i"}
                                    info={"Тип заказа"}
                                    title={"Тип заказа"}
                                    titleShift={0}
                                ></InputItem>
                            </div>



                        </div>
                        <div className={"row w-100"}>
                            <div className={["col-xl-4   col-lg-6 col-md-12", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.region ? orderInfo?.region : ""}
                                    mode={"i"}
                                    info={"Регион тарифа"}
                                    title={"Регион"}
                                    titleShift={-1}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-4 col-lg-6 col-md-6", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.tarif ? orderInfo?.tarif : ""}
                                    mode={"i"}
                                    info={"Наименовние тарифа"}
                                    title={"Тариф"}
                                    titleShift={-1}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-4 col-lg-6 col-md-6", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.operId ? orderInfo?.operId : ""}
                                    mode={"i"}
                                    info={"Оператор"}
                                    title={"Оператор"}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-6 col-lg-6", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.ctn ? orderInfo?.ctn : ""}
                                    mode={"i"}
                                    info={"Ваш номер, или номер MNP при переходе"}
                                    title={getCtnTypeText()}
                                ></InputItem>
                            </div>


                        </div>
                        <div className={"row w-100"}>
                            <div className={["col-xl-3 col-lg-4", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.pay ? orderInfo?.pay : ""}
                                    mode={"i"}
                                    info={"Сумма заказа"}
                                    title={"Сумма заказа"}
                                    titleShift={2}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-9 col-lg-8", styles.lsFont, styles.lsState].join(' ')}>
                                <InputItem
                                    val={orderInfo?.stateText ? orderInfo?.stateText : "-"}
                                    mode={"i"}
                                    info={"Текущий статус заказа"}
                                    title={"Статус"}
                                    titleShift={-2}
                                ></InputItem>
                            </div>


                        </div>
                        <div className={"row w-100"}>
                            <div className={["col-xl-3 col-lg-6", styles.lsFont, styles.lsBill].join(' ')}>
                                {orderInfo && orderInfo?.amount > 0 &&
                                    <div className={styles.billRef}
                                         onClick={()=>handleBill()}

                                    >Кассовый чек</div>
                                }

                            </div>

                        </div>

                        {orderInfo && orderInfo?.regMode === 10 &&

                            <div className={"row w-100 "}>
                                <div className={["col-xl-4 col-lg-12 d-flex align-items-center", styles.lsFont].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.tmpCtn ? orderInfo?.tmpCtn : ""}
                                        mode={"i"}
                                        info={"Временный номер, при процедуре mnp"}
                                        title={"Временный номер"}
                                        titleShift={0}
                                        minWidth={"100%"}
                                    ></InputItem>
                                </div>
                                <div className={["col-xl-8 col-lg-12", styles.lsFont].join(' ')}>
                                    <div className={styles.mnpNote}>
                                        <p>
                                            Если Ваш номер <span>+7{orderInfo?.ctn}</span> уже перестал работать, а Вы еще не получили временный номер - это означает, что переход уже состоялся и Вам следует получить
                                            уже Ваш номер <span>+7{orderInfo?.ctn}</span> в салоне <span>{orderInfo?.operId}</span>

                                        </p>
                                    </div>
                                </div>

                            </div>


                        }



                            <div className={"row w-100"}>
                                <div className={["col-xl-12", styles.lsFont, styles.lsComm].join(' ')}>
                                    <InputItem
                                        val={orderInfo?.note ? orderInfo?.note : ""}
                                        mode={"i"}
                                        info={"Комментарий по заказку от администрации"}
                                        inputType={2}
                                        lineCount={6}
                                        title={"Комментарий"}
                                        titleShift={-3}
                                    ></InputItem>
                                </div>

                            </div>


                        <div className={styles.actCont}>
                            {!!orderId &&
                                <>

                                    {false &&
                                        <div className={styles.btnCont}>
                                            <button type="button" className="btn btn-secondary "
                                                    onClick={(e)=>handleRequestActivate()}
                                                    disabled={orderInfo?.regMode === 10 || orderInfo?.regMode === 1 ||  orderInfo?.regMode === 2 || !reqActivate}
                                            >Запросить активацию</button>
                                        </div>

                                    }
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-secondary "
                                                onClick={(e)=>setShowAppeal(true)}
                                        >Обращение</button>
                                    </div>
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-secondary "
                                                onClick={(e)=>setShowRecall(true)}
                                        >Презвоните мне</button>
                                    </div>
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-secondary "
                                                onClick={(e)=>setShowRefund(true)}
                                        >Оформить возврат</button>
                                    </div>
                                </>
                            }
                        </div>
                    </div>



                    <div className={styles.itmCont}>
                        <div className={styles.orTitle}>Данные оператора доставки</div>
                        <div className={"row w-100"}>
                            <div className={["col-xl-3 col-lg-7 col-md-6", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.customer ? orderInfo?.customer : "Не определен"}
                                    mode={"i"}
                                    info={"Оператор доставки"}
                                    title={"Оператор доставки"}
                                    titleShift={2}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-4 col-lg-5 col-md-6", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.deliveryCtn ? orderInfo?.deliveryCtn : "Не определен"}
                                    mode={"i"}
                                    info={"Номер телефона для доставки"}
                                    title={"Телефон для доставки"}
                                    titleShift={2}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-5 col-lg-12", styles.lsFont, styles.lsComm].join(' ')}>
                                <InputItem
                                    val={orderInfo?.track ? orderInfo?.track : ""}
                                    mode={"i"}
                                    info={"Трэк для отслеживания"}
                                    title={"Трэк отслеживания"}
                                    titleShift={2}
                                ></InputItem>
                            </div>


                        </div>
                        <div className={"row w-100"}>
                            <div className={["col-xl-7", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.address ? orderInfo?.address : "Не определен"}
                                    mode={"i"}
                                    info={"Адрес пункта доставки"}
                                    title={"Адрес пункта доставки"}
                                    titleShift={-1}
                                ></InputItem>
                            </div>
                            <div className={["col-xl-5", styles.lsFont].join(' ')}>
                                <InputItem
                                    val={orderInfo?.client ? orderInfo?.client : "Не определен"}
                                    mode={"i"}
                                    info={"Получатель"}
                                    title={"Получатель"}
                                    titleShift={-1}
                                ></InputItem>
                            </div>


                        </div>
                        <div className={styles.actCont}>
                            {!!orderId &&
                                <>
                                    <div className={styles.btnCont}>
                                        <button type="button" className="btn btn-secondary "
                                                onClick={(e)=>setShowOrderStatus(true)}
                                        >Отследить</button>
                                    </div>
                                    {showOrderStatus &&
                                        <OrderEngineStatus orderId={orderInfo?.orderId ? orderInfo?.orderId : "-" } onClose={()=>setShowOrderStatus(false)}/>

                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>


                <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
            </MainFormTemplate>

            <div className={styles.olCont}>
                <div className={styles.tblTitle}>Выберите заказ в таблице</div>
                <TableItem
                    column={[
                        {
                            title:"Заказ",
                            type: 0,
                            maxLen: 11,
                            fieldId:"orderId",
                            mode: "sf",
                        },
                        {
                            title:"Дата",
                            type: 2,
                            maxLen: 10,
                            fieldId:"createdAt",
                            mode: "sf",
                        },
                        {
                            title:"Тариф",
                            type: 0,
                            maxLen: 30,
                            fieldId:"tarifName",
                            mode: "sf",
                        },
                        {
                            title:"Оператор",
                            type: 0,
                            maxLen: 10,
                            fieldId:"operId",
                            mode: "sf",
                        },
                        {
                            title:"Номер",
                            type: 0,
                            maxLen: 20,
                            fieldId:"ctn",
                            mode: "sf",
                        },


                    ]}
                    onPageCount={10}
                    data={orderList}
                    exportExcel={true}
                    onRecord={(e)=>setOrderId(e?.orderId)}
                    baseState={{
                        state: baseState,
                        setState: setBaseState
                    } }
                    saveState={true}
                    onReload={()=>loadOrderList()}



                ></TableItem>
            </div>


        </div>
    )
}